import { api } from 'api'

export const getInnInfo = (inn: string) => {
    return api.dadata.inn(inn)
}

export const getBankInfo = (bic: string) => {
    return api.dadata.bank(bic)
}
